app.service('deliveryDateCalculator',function(productCardConfig, console) {
	var $self, $selectDelivery, $deliveryTabs;
	var config = false;

	function changeDeliveryType(value) {
		$deliveryTabs.removeClass();
		$deliveryTabs.addClass('show-tab-' + value);
	}

	function loadSuccess(html){
		console.log('ZAŁADOWANIE ZAKŁADKI: SPRAWDŹ TERMIN DOSTAWY - WYBRANE MIASTO');
		$self.html(html);
		setElements();
		setEvents();
	}
	function loadError(){
		console.log('BŁąD ŁADOWANIA ZAKŁADKI');
		modal.alert('Wystąpił błąd ładowania zakładki. Prosimy spróbować później');
	}
	function load(form, callback){
		if (!config) {
			$self=$('#delivery-date-selected-city');
		}
		config=productCardConfig.getData()

		$(form).ajaxSubmit({
			url:'/delivery-city-selection.ltr',
			data:{
				productId:config.id,
				outletCategoryId: config.activeOutletCategory
			},
			success:function(htmlContent){
				loadSuccess(htmlContent);
				callback();
			},
			error:function(){
				loadError();
				callback();
			}
		});
	}

	function setEvents(){
		$selectDelivery.on('change', function() {
			changeDeliveryType($(this).val());
			UA.pageInteraction('Dostępność produktu', 'Sprawdź termin dostawy - ' + $(this).val());
		});
	}
	function setElements(){
		$selectDelivery=$('#option-delivery-select', $self);
		$deliveryTabs=$('#delivery-tabs', $self);
	}

	return {
		load:load
	};
});
